export const injectAxiosIntercptor = (_axios, projectCode) => {
  _axios.interceptors.request.use((config) => {
    const _url = new URL(config.baseURL.slice(0, -1) + config.url);
    let _query = _url.search;
    let _symbol = "&";

    config.headers["idt-token"] = localStorage.getItem("Idt-Token") || "token";
    config.headers['idt-projectcode'] = localStorage.getItem('Idt-ProjectCode') || projectCode; // prettier-ignore
    config.headers["idt-useragent"] = window.navigator.userAgent;
    config.headers['idt-userflag'] = localStorage.getItem('Idt-UserFlag') || 'userFlag'; // prettier-ignore

    if (_query.indexOf("?") === -1) _symbol = "?";
    _query += `${_symbol}r=${Math.random()}`;
    config.url = `${_url.pathname}${_query}`;
    return config;
  });

  /** 不抛出错误，避免影响主流程 */
  _axios.interceptors.response.use(
    (response) => {
      const binary = response.config.binary;
      if (binary) {
        return response;
      }
      const result = response.data;
      if (result.success || result.code === "0") {
        return result.data;
      } else {
        console.error("服务异常，请稍后重试", result);
        // throw new Error('服务异常，请稍后重试 ');
      }
    },
    (error) => {
      console.error("接口调用失败，请稍后重试", error);
      // throw error;
    },
  );
};
